import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCheck } from "react-icons/fa";
import { Timeline } from "../components/Timeline";

export const AgradecemosCompra = () => {
  const navigate = useNavigate();

  const handleBackClick = () => {
    navigate('/');
  };

  return (
    <div className="container-agradecemos">
      <div style={{ width: '100%' }}>
        <Timeline currentStep={3} />
      </div>
      <div className="texto-agradecemos fade-in">
        <img
          src="http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=persona-compra.png&version_id=null"
          alt="persona compra"
          className="img-responsive-gracias fade-in"
        />
        <div className="font24 font700 font-family-montserrat fade-in">
          ¡ AGRADECEMOS{" "}
        </div>
        <div className="font-family-montserrat font20 extrabold-800 pad-acabamos color-520FDA fade-in">
          POR TU COMPRA !
        </div>
      </div>
      <span className="font-family-montserrat" style={{ paddingTop: '10px', fontWeight: '400', fontSize: '16px' }}>
        Ingresa a tu correo electrónico para revisar detalles
      </span>
      <div className="btn-atras fade-in" style={{ marginTop: '30px' }}>
        <div className="container-atras" onClick={handleBackClick} style={{ cursor: 'pointer' }}>
          <img
            src="http://172.233.171.185:9001/api/v1/buckets/web/objects/download?preview=true&prefix=arrow.png&version_id=null"
            alt="flecha boton"
            className="flecha fade-in"
          />
          <div className="font-family-montserrat color-blanco extrabold-800 texto-atras fade-in">
            INICIO
          </div>
        </div>
      </div>
    </div>
  );
}